import React from 'react';
import { Users, Building, Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Stats = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-blue-500 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="relative mb-6">
              <Users className="w-16 h-16 mx-auto mb-2" />
              <img
                src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=30&h=30&fit=crop&crop=center"
                alt="brush icon"
                className="w-6 h-6 absolute -bottom-2 left-1/2 transform -translate-x-1/2"
              />
            </div>
            <div className="text-4xl font-bold mb-2">1000+</div>
            <div className="text-lg">{t('about.stats.customers')}</div>
          </div>
          <div className="text-center">
            <div className="relative mb-6">
              <Building className="w-16 h-16 mx-auto mb-2" />
              <img
                src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=30&h=30&fit=crop&crop=center"
                alt="brush icon"
                className="w-6 h-6 absolute -bottom-2 left-1/2 transform -translate-x-1/2"
              />
            </div>
            <div className="text-4xl font-bold mb-2">500K+</div>
            <div className="text-lg">{t('about.stats.squareFeet')}</div>
          </div>
          <div className="text-center">
            <div className="relative mb-6">
              <Calendar className="w-16 h-16 mx-auto mb-2" />
              <img
                src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=30&h=30&fit=crop&crop=center"
                alt="brush icon"
                className="w-6 h-6 absolute -bottom-2 left-1/2 transform -translate-x-1/2"
              />
            </div>
            <div className="text-4xl font-bold mb-2">1990</div>
            <div className="text-lg">{t('about.stats.since')}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;